export default __webpack_public_path__ + "static/media/6-Poesias.709355d6.png";